import React, { useState, useEffect } from 'react';
import Layout from '../../components/Layout/Layout';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Button } from 'react-bootstrap';
import { FaThumbsUp,FaFilePdf } from 'react-icons/fa';
import { SERVER_API } from '../../fileWithConstants';
import { useAuth } from '../../context/auth';
import { isAdmin, hasRight } from '../../Helpers';
import { Link } from 'react-router-dom';

const IntransitThanList = () => {
  const [auth] = useAuth();
  const [userId] = useState(auth.user.id);
  const [podata, setPodata] = useState([]);
  const [warehouseMap, setWarehouseMap] = useState({});
  const [loading, setLoading] = useState(false);

  const getWareHouse = async () => {
    try {
      const { data } = await axios.get(`${SERVER_API}/api/v1/supplier/get-warehouse`);
      if (data?.success && data?.wdata.length > 0) {
        const map = {};
        data.wdata.forEach(w => {
          map[w.id] = w.name;
        });
        setWarehouseMap(map);
      } else {
        toast.error('Error loading warehouse data.');
      }
    } catch (error) {
      console.error('Warehouse Error:', error);
    }
  };

  const getIntransitFabrics = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(`${SERVER_API}/api/v1/fabric/get-all-intransit-than-data`);
      if (data?.success) {
        setPodata(data.data || []);
      } else {
        toast.error('Failed to fetch intransit data.');
      }
    } catch (error) {
      console.error('Intransit Fetch Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const approveThaanTransfer = async (fabric_id) => {
    try {
      setLoading(true);
      const { data } = await axios.post(`${SERVER_API}/api/v1/fabric/approve-intransit-than`, {
        fabric_id,
      });
      if (data.success) {
        toast.success("Thaan approved successfully.");
        getIntransitFabrics();
      } else {
        toast.error(data.message || 'Approval failed.');
      }
    } catch (error) {
      console.error('Approval Error:', error);
      toast.error('Error approving thaan transfer.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getWareHouse();
    getIntransitFabrics();
  }, []);

  return (
    <Layout title="Intransit Thaan List">
      <div className="container">
        <h1 className="page-title text-center">Intransit Thaan List</h1>
        <div className="table-box mt-3">
          {loading ? (
            <div className="text-center my-3">
              <span className="spinner-border text-dark" role="status" />
              <span className="ms-2">Loading...</span>
            </div>
          ) : (
            <table className="table table-hover table-responsive table-sticky">
              <thead>
                <tr>
                  <th>#</th>
                  <th className="text-center">Fabric</th>
                  <th className="text-center">Supplier Fabric</th>
                  <th className="text-center">Photo</th>
                  <th className="text-center">Quantity</th>
                  <th className="text-center">Thaan No.</th>
                  <th className="text-center">Warehouse</th>
                  <th className="text-center">Status</th>
                  <th className="text-center">Transfer To</th>
                  <th className="text-center">Challan</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {podata?.map((po, index) => (
                  <tr key={po.id}>
                    <td>{index + 1}</td>
                    <td>{po.name}</td>
                    <td>{po.supplierfbname}</td>
                    <td>
                        {po.fabric_photo !== '' ? (
                        <Link to={`${SERVER_API}/uploads/fabrics/${po.fabric_photo}`} target='_blank'>
                            <img
                            src={`${SERVER_API}/uploads/fabrics/${po.fabric_photo}`}
                            alt={po.name}
                            width="50"
                            />
                        </Link>
                        ) : ("")}
                    </td>
                    <td>{po.qty}</td>
                    <td>{po.than_no}</td>
                    <td>{warehouseMap[po.warehouse]}</td>
                    <td>{po.than_status === 1 ? 'Intransit' : po.than_status}</td>
                    <td>{warehouseMap[po.transfer_to_warehouse]}</td>
                   


                    <td>
                        {po.challan_pdf !== '' ? (
                        <Link to={`${SERVER_API}/uploads/than_challan/${po.challan_pdf}`} target='_blank'>
                            <FaFilePdf />
                        </Link>
                        ) : ("")}
                    </td>

                    <td>
                      <Button
                        variant="success"
                        onClick={() => approveThaanTransfer(po.id)}
                        disabled={loading}
                      >
                        <FaThumbsUp className="me-2 text-light" />
                        Approve
                      </Button>
                    </td>
                     
                  </tr>
                ))}
                {podata.length === 0 && (
                  <tr>
                    <td colSpan="9" className="text-center text-muted">No intransit records found.</td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default IntransitThanList;
